module.exports = __webpack_public_path__ + "static/img/13.5a18813.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/1/zh/13.png
// module id = DSsD
// module chunks = 0